import { createFileRoute } from '@tanstack/react-router'
import { requireAnyPermission } from '../../../../../../app/guards'
import { ClaimEditorPage } from '../../../../../../features/projects/contracting/claim-editor-page'

/** A progress claim: who runs contracts, or who reads project money. */
export const Route = createFileRoute('/_app/projects/$projectId/claims/$claimId/')({
  staticData: { crumb: 'projectClaim' },
  beforeLoad: ({ context }) =>
    requireAnyPermission(context.session, 'projects.contract', 'projects.financials'),
  component: ClaimEditorPage,
})
